import React from 'react';
import { arrivalLineColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmArrivalIntervalChart(props) {
  const { arrival, increment, d0_date, d2_date } = props;

  return (
    <AdmIntervalChartWrapper
      title='Defect Arrival Prediction'
      arrival={arrival}
      increment={increment}
      d0_date={d0_date}
      d2_date={d2_date}
      arrivalColor={arrivalLineColor}
      showArrival={true}
      showClosure={false}
    />
  );
}
